import React from 'react';
import Markdown from 'react-markdown';

/**
 * Renders a session description. Links (meeting links, maps) open in a new tab so people
 * don't lose their place in the app.
 */
export const SessionDescription = ({ markdown }: { markdown: string }) => (
    <div className="marked">
        <Markdown components={{
            a: ({ node, ...props }) => <a {...props} target="_blank" rel="noopener noreferrer" />
        }}>{markdown}</Markdown>
    </div>
)
